<script>
import { FixedBtnView } from '@/layouts'
import { pagination } from 'ant-design-vue'

export default {
  name: 'SmartTable',
  props: {
    rowKey: [String, Function],
    columns: Array,
    apiPath: String,
    baseUrl: {
      type: String,
      default: ''
    },
    param: {
      type: Object,
      default () {
        return {}
      }
    },
    rowSelection: {
      type: Object,
      default: null
    },
    showQuickJumper: {
      type: Boolean,
      default () {
        return true
      }
    },
    defaultParam: {
      type: Object,
      default () {
        return {}
      }
    },
    size: {
      type: String,
      default: 'small'
    },
    scroll: {
      type: Object,
      default () {
        return null
      }
    },
    bordered: {
      type: Boolean,
      default: false
    },
    hasPage: {
      type: Boolean,
      default: true
    },
    isFixed: {
      type: Boolean,
      default: false
    }
    // expandIcon: {
    //   type: Function,
    //   default: function (opt) {}
    // }
  },
  components: {
    FixedBtnView,
    APagination: pagination
  },
  data () {
    return {
      parameter: { pageNum: 1, pageSize: 20, paging: true },
      pagination: { pageNum: 1, pageSize: 20, total: 0, showQuickJumper: true, showSizeChanger: true, size: 'middle', hideOnSinglePage: true, showTotal: total => `${this.$t('measure_total', [total])} ` },
      loading: true,
      dataSource: [],
      selectedRowKeys: [],
      scrollY: 0
      // is
    }
  },
  watch: {
    param (newVal) {
      if (!newVal) return false
      const { parameter } = this
      this.parameter = {
        ...parameter,
        ...newVal
      }
    },
    parameter: {
      handler: 'fetch'
    },
    defaultParam: {
      immediate: false,
      handler: 'fetch'
    },
    '$root.resizeData': 'resize'
  },
  methods: {
    setParam (obj) {
      this.parameter = { ...obj }
    },
    updateDataItem (record, key, updateItems) {
      this.loading = true
      this.dataSource.find((item) => {
        if (item[key] === record[key]) {
           Object.keys(updateItems).forEach((itemKey) => {
            item[itemKey] = updateItems[itemKey]
           })
        }
      })
      this.loading = false
    },
    fetch () {
      const { apiPath, defaultParam, parameter, baseUrl, hasPage, pagination } = this
      this.loading = true
      this.pagination = {
        ...pagination,
        current: parameter.pageNum,
        pageSize: parameter.pageSize
      }
      this.pagination.pageNum = parameter.pageNum
      // this.dataSource = []
      this.$http({
        baseURL: baseUrl,
        url: apiPath,
        method: 'POST',
        data: { ...defaultParam, ...parameter }
      }).then(res => {
        console.log('res', res)
        const { dataList, total, pageSize, pageNum } = res
        this.pagination = hasPage && { ...this.pagination, total, pageSize, current: pageNum }
        // 删除
        // this.pagination.total = 25
        if (dataList?.length) {
          this.dataSource = dataList.map(item => {
            const oneObj = JSON.parse(JSON.stringify(item))
            oneObj.childrenData = []
            oneObj.childrenData.push(item)
            return {
              // state: state ? Math.floor(Math.random() * (3 - 1 + 1) + 1) : '',
              ...oneObj,
              _loading: false
            }
          })
          // 删除
          this.$emit('tableNoData', false)
        } else {
          this.dataSource = []

          const filterArr = ['pageNum', 'pageSize', 'paging']
          let count = 0
          const _parameter = Object.keys(parameter).filter(key => !filterArr.includes(key))
          for (let i of _parameter) {
            if (parameter[i] === [] || !parameter[i]) {
              count++
            }
          }
          // 代表进来就是空的
          if (count === _parameter.length) {
            this.$emit('dataEmpty')
          }
          this.$emit('tableNoData', true)
        }
        this.resize()
        this.$emit('getDataSource', this.dataSource)
      }).catch(error => {
        this.$emit('error', error)
      }).finally(() => {
        this.loading = false
        this.$emit('finished', this.dataSource)
      })
    },
    handleTableChange (pageNum) {
      const { pagination, parameter } = this
      this.parameter = { ...parameter, pageNum }
      this.pagination = { ...pagination, pageNum }
    },
    onShowSizeChange (pageNum, pageSize) {
      const { pagination, parameter } = this
      this.parameter = { ...parameter, pageSize, pageNum }
      this.pagination = { ...pagination, pageSize, pageNum }
    },
    resize () {
      const rect = this.$refs['tableBox'].getBoundingClientRect()
      this.scrollY = window.innerHeight - rect.top - 42 - 56 - (window.innerWidth < 1200 ? 6 : 0) - 12
    }
  },
  render () {
    const locale = {
      emptyText:
      <a-empty
        image={ 'http://file.eccang.com/ec-saas-file/manager/saas_1648695073893a6157855b131c977.png?Expires=4802295073&OSSAccessKeyId=LTAI4FwuSvzhB2y5nmjx4NCY&Signature=jPbh41CBdw6i9bwDP66BIrwA6fw%3D' }
      >
        <span slot="description">{this.$t('empty_data')}</span>
      </a-empty>
    }
    const { loading, dataSource, pagination, size, rowKey, scroll, bordered, columns, rowSelection, isFixed } = this
    const props = { loading, dataSource, pagination: false, size, rowKey, locale, scroll: { ...scroll }, bordered, columns, rowSelection }
    if (!this.scroll) {
      delete props.scroll
    } else {
      let offset = 0
      if (pagination && (pagination.total < pagination.pageSize)) {
        offset = 10
      }
      props.scroll.y = (this.scrollY || props.scroll.y) + offset
    }
    const paginationRender = (
      <a-pagination
        current={ this.pagination.pageNum }
        pageSize={ this.pagination.pageSize }
        total={ this.pagination.total }
        showQuickJumper={ this.showQuickJumper }
        showSizeChanger={ this.pagination.showSizeChanger }
        size='middle'
        hideOnSinglePage={ true }
        onChange={this.handleTableChange}
        onShowSizeChange={this.onShowSizeChange}
        showTotal={this.pagination.showTotal}
      >
      </a-pagination>
    )
    let fixedPaginationRender = null
    if (isFixed) {
      fixedPaginationRender = (
        <fixed-btn-view vShow={ pagination.total > pagination.pageSize }>
          { paginationRender }
        </fixed-btn-view>
      )
    } else {
      fixedPaginationRender = (
        <div style="padding: 12px 0px 0px 0px;text-align: right;">
          { paginationRender }
        </div>
      )
    }
    return (
      <div class="smart-table-box" ref="tableBox">
        <a-table class="smart-table" {...{ props, scopedSlots: { ...this.$scopedSlots } }} onChange={this.handleTableChange}>
          { Object.keys(this.$slots).map(name => (<template slot={name}>{this.$slots[name]}</template>)) }
        </a-table>
        { fixedPaginationRender }
      </div>
    )
  }
}
</script>

<style lang="less" scoped>
/deep/ .anticon {
  font-size: 12px;
}
</style>
